/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import PropTypes from 'prop-types';
import './Text.scss';

/**
 * This is the Text component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function Text({ children, dropcap }) {
  let decorations = { 'appear-text': 'true' };

  if (dropcap) {
    decorations = {
      ...decorations,
      dropcap: 'true',
    };
  }

  return (
    <div
      className="body-text text"
      dangerouslySetInnerHTML={{ __html: children }}
      {...decorations}
    />
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
Text.propTypes = {
  children: PropTypes.string,
  dropcap: PropTypes.bool,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
Text.defaultProps = {
  children: '',
  dropcap: false,
};

export default Text;
